'use client';
import React from 'react';

import Image from 'next/image';
import { FeatureCard } from './components';
import { graphic, organiser, popper, share } from './images';

const features = [
  {
    icon: popper,
    title: 'Seamless Event Check-In with Greet',
    description:
      "Effortlessly manage event attendance! Greet's QR code scanning feature empowers organizers to swiftly confirm attendee presence at the event venue, ensuring a smooth and hassle-free check-in experience for everyone involved.",
  },
  {
    icon: share,
    title: 'Empower Your Events with Real-Time Insights',
    description:
      "Unlock the potential of your events' success! Greet provides event organizers with a comprehensive analytics dashboard, offering real-time data on sales, ticket bookings, and more.",
  },
];

const OrganiserSection = () => (
  <div className='relative bg-[#FE3838]'>
    <Image
      loader={(option) => option.src}
      className='absolute size-full object-cover'
      src={graphic}
      alt='icon'
    />

    <div className='mx-auto grid max-w-7xl grid-cols-1 overflow-hidden pl-4 sm:pl-6 lg:grid-cols-2'>
      <div className='flex flex-col justify-center'>
        <h1 className='mt-10 text-center text-xl font-extrabold text-white md:text-2xl lg:mt-0 lg:text-left lg:text-[32px] xl:text-5xl'>
          Exclusive App For Organiser
        </h1>
        <div className='flex flex-col pr-4 md:flex-row md:gap-4 lg:flex-col lg:gap-0'>
          <FeatureCard {...features[0]} className='lg:mt-6 xl:mt-10' />
          <FeatureCard
            {...features[1]}
            className='mt-[22px] md:mt-10 lg:mt-[22px] xl:mt-12'
          />
        </div>
      </div>
      <div className='md:mt-10 lg:mt-0'>
        <Image
          loader={(option) => option.src}
          src={organiser}
          className='bottom-0 -mb-10 md:-my-10 lg:-mb-10'
          alt='organiser'
        />
      </div>
    </div>
  </div>
);

export default OrganiserSection;
